module.exports = __webpack_public_path__ + "static/img/light1.d0ad12d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/traffic/light1.png
// module id = m11I
// module chunks = 1